<template>
    <v-dialog v-model="dialog" width="700px">
        <v-card>
            <v-card-title class="justify-center">Copy layout</v-card-title>
            <v-divider/>
            <v-card-text>Copy layout from another accommodation</v-card-text>
            <v-divider/>
            <v-card-text>
                <v-row no-gutters class="ma-4">
                    <v-col cols="2"></v-col>
                    <v-col cols="8">
                        <v-autocomplete v-model="huis_source" return-object :items="huis_list" item-text="huis_naam" item-value="huis_code" dense clearable label="Accommodation"/>
                    </v-col>
                    <v-col cols="2"></v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small :disabled="!huis_source" @click="cpyHuisHsii">Copy layout</v-btn>
                <v-btn color="primary"      small                          @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>    
    export default {
        data() { 
            return {
                dialog: false,
                huis_encrid: "",
                huis_source: null,
                huis_list: [],
            }
        },
        mounted() {
        },
        methods: {
            openDialog(huis_encrid) {
                this.huis_encrid = huis_encrid;
                this.huis_source = null;
                this.getHuisList(huis_encrid);
            },
            getHuisList(huis_encrid) {
                this.$axios.post("ares/json/ares/huis/hsii/getHuisList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisList"
                    },
                    getHuisList: {
                        huis_encrid: huis_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {
                        this.huis_list = res.data.getHuisList;
                        this.dialog = true;
                    }
                });
            },
            cpyHuisHsii() { 
                this.$axios.post("ares/json/ares/huis/hsii/cpyHuisHsii.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "cpyHuisHsii"
                    },
                    cpyHuisHsii: {
                        huis_encrid_to: this.huis_encrid,
                        huis_code_from: this.huis_source.huis_code,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        }); 
                    } else {     
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.cpyHuisHsii.text,
                            color: res.data.cpyHuisHsii.color
                        }); 
                        if (res.data.cpyHuisHsii.color === "success") {
                            this.$emit("refreshLayout");
                            this.closeDialog();
                        }
                    }
                });
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>
